<template>
  <div class="goodDetail">
    <!-- 轮播图 -->
    <van-swipe height="400" @change="onChange">
      <van-swipe-item
        v-for="(image, index) in goodDetail.fileList"
        :key="index"
      >
        <img :src="image.path" class="banner-img" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator" v-if="goodDetail && goodDetail.fileList">
          {{ currentIndic + 1 }}/{{ goodDetail.fileList.length }}
        </div>
      </template>
    </van-swipe>
    <!-- 内容 -->
    <div class="good-info">
      <p class="title">{{ goodDetail.comments }}</p>
      <div class="auther-info">
        <div class="left">
          <div class="header">
            <img
              :src="goodDetail.memberHeadUrl"
              alt=""
              class="header-img"
              v-if="goodDetail.memberHeadUrl"
            />
            <img
              src="@/assets/images/default-header.png"
              alt=""
              class="header-img"
              v-else
            />
          </div>
          <div class="info">
            <div class="nick-name">
              <p class="name-text">{{ goodDetail.memberName }}</p>
              <div class="gf" v-if="goodDetail.memberId === '1'">
                <span class="gf-text">官方</span>
              </div>
            </div>
            <p class="date">{{ goodDetail.createTime }}</p>
          </div>
        </div>
        <div class="right">
          <span class="text">{{
            goodDetail.type === 'J' ? '起拍价' : '一口价'
          }}</span>
          <span class="point">{{ goodDetail.score }}</span>
          <span class="text">点</span>
        </div>
      </div>
    </div>
    <!-- 评论 -->
    <comment-list type="good" :addParams="params" />
    <open-app />
  </div>
</template>

<script>
import { getGoodDetail } from '@/service/api'
import CommentList from '@/components/CommentList.vue'
import { getUrlParams } from '@/utils'
import OpenApp from '@/components/OpenApp.vue'
export default {
  components: { CommentList, OpenApp },
  data() {
    return {
      goodDetail: {},
      currentIndic: 0,
      isShowMore: false,
      //评论参数
      params: {
        giveId: '',
      },
    }
  },
  created() {
    this.params.giveId = getUrlParams('goodsId')
  },
  mounted() {
    this._getGoodDetail()
  },
  methods: {
    onChange(index) {
      this.currentIndic = index
    },
    showMore() {
      this.isShowMore = true
    },
    //获取物品详情
    async _getGoodDetail() {
      const id = getUrlParams('goodsId')
      try {
        const res = await getGoodDetail(id)
        if (res) {
          this.goodDetail = res
        }
      } catch (error) {
        this.$toast(`${error}`)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.goodDetail {
  width: 100%;
  // padding-bottom: 70px;
  .banner-img {
    width: 100%;
    height: 100%;
  }
  //banner指示器
  .custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.2);
    color: #fff;
  }
  .good-info {
    padding: 10px 15px;

    .title {
      font-size: 20px;
      font-weight: 600;
      margin-top: 10px;
    }
    .auther-info {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .left {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .header {
          width: 50px;
          height: 50px;
          border-radius: 30px;
          overflow: hidden;
          .header-img {
            width: 100%;
            height: 100%;
          }
        }
        .info {
          padding-left: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          .nick-name {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            .name-text {
              font-size: 16px;
            }
            .gf {
              width: 34px;
              height: 20px;
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              background-color: #1296db;
              border-radius: 20px;
              margin-left: 4px;
              .gf-text {
                font-size: 10px;
                color: #fff;
              }
            }
          }
          .date {
            font-size: 12px;
            margin-top: 4px;
            // font-family: 'DIN_Alternate';
            color: #9e9e9e;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .right {
        width: 140px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .text {
          font-size: 12px;
        }
        .point {
          font-size: 30px;
          margin: 0 2px;
          color: #f17c25;
          font-weight: bold;
          font-family: 'DIN_Alternate';
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
